var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlurredTenant',{attrs:{"showBlur":_vm.showBlur}},[(_vm.loading)?_c('loading'):_c('v-container',[_c('x-form',{attrs:{"x-options":_vm.formOptions,"x-container":_vm.formContainer,"x-data":_vm.dataContainer,"x-context":_vm.self}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }